if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    connectedCallback() {
      this.fetchAvailability(this.dataset.variantId);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    clearAvailability() {
      this.controller?.abort();
      this.dataset.variantId = '';
      this.removeAttribute('aria-busy');
      this.removeAttribute('available');
      this.replaceChildren();
    }

    async fetchAvailability(variantId) {
      this.controller?.abort();
      if (!variantId) return this.clearAvailability();
      this.dataset.variantId = String(variantId);
      const controller = new AbortController();
      this.controller = controller;
      this.setAttribute('aria-busy', 'true');
      this.textContent = 'Verfügbarkeit wird geprüft …';
      const root = (this.dataset.rootUrl || '/').replace(/\/?$/, '/');
      try {
        const response = await fetch(`${root}variants/${encodeURIComponent(variantId)}/?section_id=pickup-availability`, { signal: controller.signal });
        if (!response.ok) throw new Error('Availability request failed');
        const html = await response.text();
        if (controller.signal.aborted) return;
        const preview = new DOMParser().parseFromString(html, 'text/html').querySelector('pickup-availability-preview');
        if (!preview) throw new Error('Availability response missing');
        this.replaceChildren(preview);
        this.setAttribute('available', '');
      } catch (error) {
        if (controller.signal.aborted) return;
        this.textContent = 'Verfügbarkeit derzeit nicht abrufbar. ';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'link underlined-link';
        button.textContent = 'Erneut versuchen';
        button.addEventListener('click', () => this.fetchAvailability(this.dataset.variantId));
        this.appendChild(button);
      } finally {
        if (!controller.signal.aborted) this.removeAttribute('aria-busy');
      }
    }
  });
}
